module.exports = __webpack_public_path__ + "static/media/38.d3fceb2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/38.svg
// module id = 2829
// module chunks = 3